import {
    DIC
} from '@/const/dic'
import {
    baseUrl
} from '@/config/env';
import {
    formatterTime
} from '@/util/util'

export const videosOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    columnBtn: false,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuType: "menu",
    menuWidth: '300',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "视频名称",
            prop: "name",
            offset: 5, //当前偏移量
            search: true,
            type: "input",
            span: 13,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入视频名称"
            }]
        },
        {
            label: "请选择商品分类",
            prop: "firstClassifyName",
            type: "select",
            span: 13,
            placeholder: "请选择商品一级分类",
            hide: true,
            formsolt: true
        },
        {
            label: "",
            prop: "secondClassifyName",
            span: 13,
            type: "select",
            placeholder: "请选择商品二级分类",
            formsolt: true,
            hide: true,
        },
        {
            label: "选择商品",
            prop: "goodsId",
            span: 13,
            type: "select",
            placeholder: "请选择商品",
            hide: true,
            formsolt: true,
        },
        {
            label: "选择优惠卷",
            prop: "couponId",
            span: 13,
            type: "select",
            placeholder: "请选择商品优惠卷",
            hide: true,
            formsolt: true
        },
        {
            label: "绑定商品名称",
            prop: "goodsName",
            width: "150",
            search: true,
            type: "input",
            span: 13,
            editVisdiplay: false,
            addVisdiplay: false,
            // dicData: DIC.FINANCIAL_SOURCE,
        },
        // {
        //     label: "投放端口",
        //     prop: "clientType",
        //     span: 13,
        //     search: true,
        //     addVisdiplay: false,
        //     dicData: DIC.WALLET_USER_TYPE,
        //     type: "input",

        // },
        {
            label: "视频投放端口",
            prop: "clientType",
            span: 13,
            type: "select",
            formsolt: true,
            // multiple: true,
            // solt: true,
            // search: true,
            // width: '180',
            // placeholder: "请选择视频投放端口",
            dicData: DIC.WALLET_USER_TYPE,
            formatter: function (row, value, label, column) {
                if (row.clientType.length > 18) {
                    row.clientType = row.clientType.split(',')
                }
                // else{
                //     let arr = []
                //     arr.push(row.clientType)
                //     console.log(arr)
                //     row.clientType = arr
                // }
                return row.clientType
            }
        },
        {
            label: "",
            prop: "classify",
            span: 13,
            type: "select",
            formsolt: true,
            hide:true,
            // multiple: true,
            // solt: true,
            // search: true,
            // width: '180',
            // placeholder: "请选择视频投放端口",
            // dicData: DIC.WALLET_USER_TYPE,
        },
        {
            label: "视频投放地区",
            prop: "address",
            span: 13,
            width: "110",
            type: "input",
            placeholder: "请选择省份",
            editVisdiplay: false,
            addVisdiplay: false,
        },
        {
            label: '视频投放地区',
            prop: 'province',
            type: 'select',
            cascader: ['city'],
            span: 13,
            // search: true,
            props: {
                label: 'name',
                value: 'id'
            },
            placeholder: "请选择省份",
            cascaderFirst: true,
            hide: true,
            dicUrl: `${baseUrl}/joins-basic/v1/province`,
            dicData: 'province'
        }, {
            label: '城市',
            prop: 'city',
            type: 'select',
            cascader: ['area'],
            span: 13,
            // search: true,
            props: {
                label: 'name',
                value: 'id'
            },
            placeholder: "请选择城市",
            // dicFlag: false,
            // cascaderFirst: true,
            hide: true,
            dicUrl: `${baseUrl}/joins-basic/v1/province/citys/{{key}}`,
            dicData: 'city'
        }, {
            label: '区/县',
            prop: 'area',
            span: 13,
            // search: true,
            props: {
                label: 'name',
                value: 'id'
            },
            placeholder: "请选择区/县",
            // dicFlag: false,
            // cascaderFirst: true,
            type: 'select',
            hide: true,
            dicUrl: `${baseUrl}/joins-basic/v1/province/areas/{{key}}`,
            dicData: 'area'
        },
        {
            label: "绑定优惠卷名称",
            search: true,
            prop: "couponName",
            span: 13,
            width: "150",
            // solt: true,
            type: "input",
            editVisdiplay: false,
            addVisdiplay: false,
        },

        {
            label: "视频状态",
            prop: "status",
            search: true,
            type: "select",
            dicData: DIC.VIDEO_STATUS,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "视频文件",
            prop: "cover",
            type: 'input',
            solt: true,
            editVisdiplay: false,
            addVisdiplay: false,
            span: 24
        },
        {
            label: "上传视频",
            prop: "vodId",
            type: 'input',
            solt: true,
            hide: true,
            formsolt: true,
            span: 24
        },
        {
            label: "观看人数",
            prop: "personCount",
            editVisdiplay: false,
            addVisdiplay: false,
            type: "input",
            formatter: function (row, value, label, column) {
                return row.personCount == null ? 0 : row.personCount
            }
        },
        {
            label: "播放量",
            prop: "browseCount",
            editVisdiplay: false,
            addVisdiplay: false,
            type: "input"
        },
        {
            label: "点赞量",
            prop: "likeCount",
            editVisdiplay: false,
            addVisdiplay: false,
            type: "input",
        },
        {
            label: "分享量",
            prop: "forwardCount",
            editVisdiplay: false,
            addVisdiplay: false,
            type: "input",
        },
        {
            label: "更新人",
            prop: "createBy",
            search: true,
            editVisdiplay: false,
            addVisdiplay: false,
            type: "input"
        },
        {
            label: "更新时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return row.createTime = row.createTime * 1
            }
        },

        {
            label: "创建时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                console.log(row)
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};